import { asyncAction } from 'lib/actionCreators'

export const managerProfileView = asyncAction('recruiter/MANAGER_PROFILE_VIEW')
